import React from 'react';
import { graphql } from 'gatsby';
import parse from 'html-react-parser';
//@ts-ignore
import * as styles from './onetrustcookielist.module.css';

interface Props {
    code: {
        value: string;
    };
    kontentItemId?: string;
}

const OneTrustCookieList: React.FC<Props> = ({ code, kontentItemId }) => {
    const parseCookieList = (htmlAsString: string) => {
        let html = htmlAsString;
        html = html.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
        html = html.replace(/\n/g, '');
        const cookieList = parse(html);
        return cookieList;
    };

    const cookieList = parseCookieList(code.value);

    return (
        <>
            <div
                className={styles.reviews}
                data-kontent-item-id={kontentItemId}
            >
                {cookieList}
            </div>
        </>
    );
};

export default OneTrustCookieList;

export const fragmentOneTrustCookieList = graphql`
    fragment OneTrustCookieList on kontent_item_component___onetrust_cookie_list {
        elements {
            code {
                value
            }
        }
    }
`;
